import {
  TITLE,
  DESCRIPTION,
  LANG,
  SLOGAN_PRIMARY,
  SLOGAN_SECONDARY,
} from './index';
import { DASH } from './chars';
import { COLORS } from './styles';

const APP_COLOR = COLORS.bluePrimary;

export const getAppMetadata = formatMessage => ({
  htmlAttributes: { lang: `${LANG}` },
  defaultTitle: `${formatMessage(TITLE)} ${DASH} ${formatMessage(DESCRIPTION)}`,
  title: `${formatMessage(DESCRIPTION)}`,
  titleTemplate: `${formatMessage(TITLE)} ${DASH} %s`,
  meta: [
    { charset: 'utf-8' },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover',
    },
    { name: 'x-ua-compatible', content: 'ie=edge' },
    { name: 'theme-color', content: `${APP_COLOR}` },
    { name: 'description', content: `${formatMessage(SLOGAN_PRIMARY)}` },
    { name: 'description', content: `${formatMessage(SLOGAN_SECONDARY)}` },
    { name: 'apple-mobile-web-app-status-bar-style', content: `${APP_COLOR}` },
  ],
  link: [
    { rel: 'shortcut icon', href: '/favicon.ico' },
    { rel: 'apple-touch-icon', href: '/apple-icon-144x144.png' },
    {
      rel: 'apple-touch-icon',
      sizes: '144x144',
      href: '/apple-icon-144x144.png',
    },
  ],
  base: { href: '#' },
});

export const ROOT_META_DATA = {
  title: 'Messaging',
};

export const EMERGENCY_CONTACT_DATA_KEY = 'emergency_contact_attributes';
export const PHARMACY_DATA_KEY = 'emergency_contact_attributes';



// WEBPACK FOOTER //
// ./src/constants/metadata.js